import normalizeComponent from "./component-library95.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "viewBox": "0 0 137 137", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "d": "M68.5.5a68 68 0 1 0 0 136 68 68 0 0 0 0-136m0 19.43c9.88 0 19.07 2.98 26.75 8.07L28 95.25a48.3 48.3 0 0 1-8.07-26.75A48.63 48.63 0 0 1 68.5 19.93m0 97.14A48.3 48.3 0 0 1 41.73 109L109 41.73a48.3 48.3 0 0 1 8.08 26.77 48.63 48.63 0 0 1-48.57 48.57", "fill": "#B2B2B2" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
const NoAccessIcon = __component__.exports;
export {
  NoAccessIcon as default
};
